import DEFAULT_HERO from 'assets/img/img-hero.webp';

const CountryHero = ({ className, country }) => {
  const source = country?.banner ?? DEFAULT_HERO;

  if (!source) {
    return null;
  }

  return <img className={className} alt="" src={source} />;
};

export default CountryHero;
